import React from 'react';
import { AppPage, MimaButton, MimaTable } from '../../components';
import styles from '../../assets/styles/PlansBilling/PlansBilling.module.scss';
import { usePlanBilling, usePlanSubscriptions } from './logic';
import CreatePlanModal from './CreatePlanModal';
import ViewSubscriptionTx from './ViewSubscriptionTx';
import ViewPlansModal from './ViewPlansModal';

export const PlansBilling = () => {
	const {
		switchMenu,
		currentSwitch,
		setCurrentSwitch,
		openModal,
		openModalHandler,
		modalConstants,
		closeModal,
		onLimitChange,
		isLoading,
		isFetching,
		setCurrentPage,
		setSearchQuery,
		limit,
		tableData,
		tableColumns,
		currentPage,
		totalCounts,
		currentPlan,
		customerId,
		handleOptionSelect,
	} = usePlanBilling();

	const {
		loadingSubs,
		fetchingSubs,
		currentSubPage,
		setCurrentSubPage,
		setSubSearchQuery,
		subLimit,
		onSubLimitChange,
		subTableData,
		subscriptionTotalCounts,
		subTableColumns,
	} = usePlanSubscriptions({ handleOptionSelect });

	return (
		<AppPage pageTitle="Plans & Billing">
			<div className={styles.top__btn}>
				<MimaButton
					variant="filter"
					title="Create a Plan"
					width={20}
					mt={2}
					buttonColor="var(--color-primary)"
					onClick={() => {
						openModalHandler(modalConstants.createPlan);
					}}
				/>
			</div>

			<section className={styles.table__section}>
				<div className={styles.switchMenu}>
					{switchMenu?.map((x, i) => (
						<div
							key={i}
							onClick={() => {
								setCurrentSwitch(x);
							}}
							className={`${currentSwitch === x ? styles.switchMenu__active : ''} ${currentSwitch === switchMenu[0] ? styles.switchMenu__rad__l : styles.switchMenu__rad__r}`}>
							{x}
						</div>
					))}
				</div>
				{currentSwitch === switchMenu[0] ? (
					<MimaTable
						tableData={tableData}
						tableColumns={tableColumns}
						searchPlaceholder="Search Plans"
						searchVariant="wide"
						totalItems={totalCounts}
						onLimitChange={onLimitChange}
						isLoading={isLoading}
						isFetching={isFetching}
						limit={limit}
						currentPage={currentPage}
						setCurrentPage={setCurrentPage}
						setSearchQuery={setSearchQuery}
					/>
				) : (
					<MimaTable
						tableData={subTableData}
						tableColumns={subTableColumns}
						searchPlaceholder="Search Plan Subscriptions"
						searchVariant="wide"
						totalItems={subscriptionTotalCounts}
						onLimitChange={onSubLimitChange}
						isLoading={loadingSubs}
						isFetching={fetchingSubs}
						limit={subLimit}
						currentPage={currentSubPage}
						setCurrentPage={setCurrentSubPage}
						setSearchQuery={setSubSearchQuery}
					/>
				)}
			</section>

			{openModal === modalConstants.createPlan && (
				<CreatePlanModal closeModal={closeModal} currentPlan={currentPlan} />
			)}
			{openModal === modalConstants.viewSubscriptionDetails && (
				<ViewSubscriptionTx closeModal={closeModal} customerId={customerId} />
			)}
			{openModal === modalConstants.viewPlan && (
				<ViewPlansModal closeModal={closeModal} currentPlan={currentPlan} />
			)}
		</AppPage>
	);
};
